import React, { useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { Button, Radio, Text, Spinner } from '@ui-kitten/components'
import StyledTextInput from './StyledTextInput'
import { getClientBonusValue, updateBonusForClient } from '../global/Firebase/firebase'
import { useTranslation } from 'react-i18next'
import * as Sentry from "@sentry/react-native"

export const BonusValueChange = (props) => {
  const { t } = useTranslation()
  const db = props.db
  const client = props.client
  const [value, setValue] = useState(0)
  const onBonusUpdate = props.onBonusUpdate ? props.onBonusUpdate : (newBonusValue) => {}
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const additionOperationInfo = {
    operationName: t('bonusValueChange.addition'),
    isAddition: true
  }

  const reductionOperationInfo = {
    operationName: t('bonusValueChange.subtraction'),
    isAddition: false
  }

  const [operationInfo, setOperationInfo] = useState(additionOperationInfo)

  function applyOperation (currentValue, value, operationInfo) {
    if (operationInfo.isAddition) {
      return currentValue + value
    } else {
      return currentValue - value
    }
  }

  function changeOperationType (checked) {
    if (checked) {
      setOperationInfo(additionOperationInfo)
    } else {
      setOperationInfo(reductionOperationInfo)
    }
  }

  async function changeBonusValue () {
    setIsLoading(true)
    try {
      if (client.id) { // single client
        await updateBonusForClient(db, client.id, client.bonusValue, value, operationInfo.isAddition)
        const newBonusValue = await getClientBonusValue(db, client.id)
        onBonusUpdate(newBonusValue)
      } else { // all clients
        for (let singleClient of client) {
          await updateBonusForClient(db, singleClient.id, singleClient.bonusValue, value, operationInfo.isAddition)
        }
        onBonusUpdate()
      }
    } catch (error) {
      Sentry.captureException(error, { tags: { books_write_error: 'client-bonus-update' } })
      setError(error)
    }
    setIsLoading(false)
  }

  return (
    <>
      <StyledTextInput
        value={value}
        onChangeText={text => {
          let newValue = parseInt(text.replace(/,?-?\.?\D/g, ''))
          if (newValue) {
            setValue(newValue)
          }
        }}
        style={{marginBottom: 10}}
      />
      
      <Radio 
        style={styles.radio} checked={operationInfo.isAddition === additionOperationInfo.isAddition} 
        onChange={() => {changeOperationType(true)}}
      >
        {additionOperationInfo.operationName}
      </Radio>
      <Radio 
        checked={operationInfo.isAddition === reductionOperationInfo.isAddition} 
        onChange={() => {changeOperationType(false)}}
      >
          {reductionOperationInfo.operationName} 
      </Radio>

      { client.id && (
        <Text style={{ marginBottom: 5, marginTop: 10 }}>
          {t('bonusValueChange.newBonusValue')}: {applyOperation(client.bonusValue, value, operationInfo)}
        </Text>
      )}
      { isLoading ? (
        <View style={styles.spinner}><Spinner /></View>
      ) : (
        <Button disabled={applyOperation(client.bonusValue, value, operationInfo) < 0} onPress={changeBonusValue}
                style={{ marginTop: 15 }}>
          {t('save')}
        </Button>
      )}
      {error && (
        <Text style={styles.text} status="danger">{error.toString()}</Text>
      )
      }
    </>
  )
}

const styles = StyleSheet.create({
  text: {
    margin: 4,
  },
  spinner: {
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 10
  },
  radio: {
    marginBottom: 5
  },
})
